import { API } from './interceptor'

export const notifyParLevelPaywallSales = ({
  venueId,
  source = 'client',
  platform = 'dashboard',
  venueProductId = null,
  productTitle = null,
}) => {
  if (!venueId) {
    return Promise.resolve()
  }

  return API.post('api2', `venue/${venueId}/par-level-paywall-notify`, {
    body: {
      source,
      platform,
      venueProductId,
      productTitle,
    },
  }).catch(() => {
    // Fire-and-forget; paywall UX must not depend on sales notify
  })
}
